import { ReactNode } from 'react';
import { EventMapLegend } from '../EventMapLegend/EventMapLegend';

export const PitchVisWrapper = ({ children }: { children: ReactNode }) => (
  <figure className="h-full flex flex-col gap-2 justify-center" data-testid="pitch-figure">
    {children}
  </figure>
);

export const PitchVisWithLegend = ({
  children,
  hasShotEvents,
  hasNonShotEvents,
}: {
  children: ReactNode;
  hasShotEvents?: boolean;
  hasNonShotEvents?: boolean;
}) => (
  <PitchVisWrapper>
    {children}
    <EventMapLegend hasShotEvents={hasShotEvents} hasNonShotEvents={hasNonShotEvents} />
  </PitchVisWrapper>
);
